import React, { useEffect, useState } from "react";
import { FormControl } from "react-bootstrap";
import { useAsyncDebounce } from "react-table";
import { useIntl } from "react-intl";

type TextFilterProps = {
  currentFilters: Record<string, any>;
  setFilters: Function;
  filterKey: string;
};

function TextFilter(props: TextFilterProps) {
  const intl = useIntl();
  const { currentFilters, setFilters, filterKey } = props;
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInputValue(currentFilters[filterKey] || "");
  }, [currentFilters[filterKey]]);

  const handleChange = useAsyncDebounce((value: string) => {
    setFilters({
      ...currentFilters,
      [filterKey]: value,
    });
  }, 500);

  return (
    <div className="text-filter">
      <FormControl
        className="filter-input"
        type="text"
        placeholder={
          intl.formatMessage({
            id: "general.typeHere",
            defaultMessage: "Type here...",
          }) as string
        }
        value={inputValue}
        onChange={(e) => {
          handleChange(e.target.value);
          setInputValue(e.target.value);
        }}
      />
    </div>
  );
}

export default TextFilter;
